import { useEffect } from 'react';

import { useTranslation } from 'react-i18next';

import './CheckEmail.scss';
import Logo2 from '../../../components/Logo/Logo2';

const data = {
    en: {
        title: "Page not found",
    },
    fr: {
        title: "Page introuvable",
    },
    de: {
        title: "Seite nicht gefunden",
    },
    hi: {
        title: "पृष्ठ नहीं मिला",
    },
    id: {
        title: "Halaman tidak ditemukan",
    },
    it: {
        title: "Pagina non trovata",
    },
    ja: {
        title: "ページが見つかりません",
    },
    ko: {
        title: "페이지를 찾을 수 없습니다",
    },
    pl: {
        title: "Nie znaleziono strony",
    },
    'pt-BR': {
        title: "Página não encontrada",
    },
    'zh-CN': {
        title: "页面未找到",
    },
    es: {
        title: "Página no encontrada",
    },
    th: {
        title: "ไม่พบหน้าเว็บ",
    },
    'zh-TW': {
        title: "找不到頁面",
    },
    tr: {
        title: "Sayfa bulunamadı",
    },
    vi: {
        title: "Không tìm thấy trang",
    },
};

const Page404 = ({ type = '' }) => {
    const { t, i18n } = useTranslation();

    useEffect(() => {
        const title = data[i18n.language || 'en'].title;
        document.title = title || data.en.title;
    }, [i18n.language]);

    return (
        <div className="check-email-box">
            <Logo2 />
            <div className='check-email'>

                <div className="check-email-title not-found">404</div>

                <div className='check-email-text-wrap'>
                    <p className={`check-email-text ${type === 'diagram' ? 'not-found-diagram' : ''}`}>{type === 'diagram' ? t('pages.not_found.dont_have_access_to_diagram') : t('pages.not_found.page_not_found')}</p>
                </div>

                <a href="/diagrams" className="check-email-action not-found">
                    <span>{t('pages.not_found.back_home')}</span>
                </a>

            </div>
        </div >
    );
};

export default Page404;
